@if (alertVisible) {
  <div [@alertOverlay] class="overlay rounded">
    @if (containerVisible) {
      <div [@alertContent] class="container flex justify-center items-center p-4">
        @if (alertPhase === 'icon') {
          <fa-icon [icon]="alertIcon" [@alertContent]></fa-icon>
        }
        @if (alertPhase === 'message') {
          <div class="flex flex-col justify-center items-center" [@alertContent]>
            <fa-icon [icon]="'check'"></fa-icon>
            <p class="text-center">{{ alertText }}</p>
          </div>
        }
      </div>
    }
  </div>
}
